import React, { useEffect, useState } from 'react';
import axios from 'axios';
import  { connect } from 'react-redux';
import styled from 'styled-components';
import { Tabs, Collapse } from 'antd';
import DetailsPreview from './DetailsPreview';
import Details from './Details';

const DetailsPane = ({ store, dlObject, File, $rootScope, previewPane, endpoint }) => {

  const defaultDetails = {
    properties: [],
    workflows: [],
    notes: [],
    recordPolicy: [],
    dependencies: {
      primary: [],
      children: [],
      projects: []
    }
  }

  const [details, setDetails] = useState(defaultDetails);
  const [preview, setPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  let statusImage = '';

  useEffect(() => {

    var _items = [];

    _items.push({
      label: 'Details',
      key: '1',
      children: <Details
                  loading={loading}
                  details={details}
                  endpoint={endpoint}
                  dlObject={dlObject}
                  statusImage={statusImage}
                />
    });

    previewPane && _items.push({
      label: 'Preview',
      key: '2',
      children: preview && <DetailsPreview
                  store={store}
                  angularScope={$rootScope}
                  dlObject={dlObject}
                  preview={preview}
                />
    });

    setItems(_items);

  }, [details,
      dlObject,
      loading,
      statusImage,
      endpoint,
      previewPane,
      $rootScope,
      store,
      preview
    ])
  

  useEffect(() => {

    setLoading(true);

    const CancelToken = axios.CancelToken;
0
    let cancelToken;

    if (dlObject.ID) {
      //cancel any pending request when someone selects a new file
      axios.get(`/api/filedetails/getdetails?id=${dlObject.ID}`, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancelToken = c;
        })
      }).then((res) => {
        setDetails(res.data);
        setLoading(false);
        setCancel(null);
      }).catch(() => {})
    }

    return () => {
      cancelToken && cancelToken();
    }
  }, [dlObject])

  var s = dlObject.Status;
  var a = dlObject.Activity;

  if (s === 'Checked Out') {
    statusImage = a === 'In Process' ? 'check-cog' : 'check';
  } else {
    if (s === "Approved") {
      statusImage = a === 'In Process' ? 'blue-yellow-cog' : 'blue-cog';
    } else {
      if (a === 'In Process') {
        statusImage = 'yellow-cog';
      }
    }
  }

  return (
    <TabWrapper>
      <Tabs
        type="card"
        items={items}
        defaultActiveKey="1"
        tabBarGutter={0}
        style={{ marginTop: '-1px', height: '100%' }}
        onChange={(index) => { setPreview(index === '2')}}
      />
    </TabWrapper>
  )
}

const TabWrapper = styled.div`
  height: 100%;
  .ant-tabs-tab {
    border-radius: 0 !important;
  }
`

const mapStateToProps = state => { 
  const { previewPane, endpoint } = state.app;
  return { previewPane, endpoint };
};

export default connect(mapStateToProps)(DetailsPane);